const initialState = {
  systemId: null,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case "LoginTrueUser": {
      localStorage.setItem("systemId", action.systemId);
      return {
        systemId: action.systemId,
      };
      break;
    }
    default: {
      return initialState;
    }
  }
}
export default reducer;
